'use strict';
var React = require('react');
let BaseComponent = require('../shared/base');

class ValuePropositionPanelsHome extends BaseComponent {

    render() {   
        let index = 0;
        var Url = "";
        return (
        <div className="section section-item" style={{marginBottom: '40px'}}>
                <div className="container">
                    <div className="group-list">
                        
                            <div className="item-list-container" key={index++}>
                                <div className="content">
                                    <div className="square-img">
                                        {
                                            <img src="/assets/images/bepensa/busqueda.jpg" width="135" height="126" alt="Búsqueda" />
                                        }
                                    </div>
                                    {/* <div className="content-title"><h3>Búsqueda avanzada</h3></div>*/}
                                    <div className="value-propasal-c">
                                        <div className="value-propasal-txt">Encuentra tus productos de manera
                                             ágil y sin complicaciones. </div>
                                         <div className="value-propasal-txt">Conoce las especificaciones de
                                             cada parte en su  ficha técnica.
                                        </div>
                                    </div>
                                    {/*<div className="content-desc">Conoce las especificaciones de cada parte en su  ficha técnica.</div>*/}
                                </div>
                            </div>
                            <div className="item-list-container" key={index++}>
                            <div className="content">
                                <div className="square-img">
                                    {
                                           <img src="/assets/images/bepensa/transporte.jpg" width="135" height="126" alt="Transporte" />
                                    }
                                </div>
                                {/*<div className="content-title"><h3>Partes originales</h3></div>*/}
                                <div className="value-propasal-c">
                                    <div className="value-propasal-txt">Recoge tu pedido en sucursal, envíalo
                                        ocurre o recíbelo en el domicilio de tu elección.</div>
                                    <div className="value-propasal-txt">Para tu comodidad, dale seguimiento a tu
                                        pedido y rastréalo hasta la entrega.</div>
                                </div>
                            </div>
                        </div>
                        <div className="item-list-container" key={index++}>
                        <div className="content">
                            <div className="square-img">
                                {                                    
                                    <img src="/assets/images/bepensa/pagos.jpg" width="135" height="126" alt="Pagos" />
                                }
                            </div>
                            {/*<div className="content-title"><h3>Precios competitivos</h3></div>*/}
                            <div className="value-propasal-c">
                                <div className="value-propasal-txt">Ahora aceptamos tarjetas de crédito,
                                    débito y transferencias bancarias.</div>
                                <div  className="value-propasal-txt">Realiza tus compras de manera segura
                                    y transparente con nosotros.</div>
                            </div>
                        </div>
                    </div>                   
                    </div>
                    <div className="divider"></div>
                </div>
            </div>
        )
    }
}

module.exports = ValuePropositionPanelsHome;